import React from 'react';
import {hoverUnderlineClass} from '../common/baseData';

function StaticMenu(props) {
  const [items, setItems] = React.useState(window.headerStaticMenu || []);

  const classRef = {
    'yellow': 'bg-yellow-10 rounded px-3 py-2',
    'header-menu-trade-in': 'header-menu-trade-in',
    'header-menu-vlasnyi-rakhunok' : 'header-menu-vlasnyi-rakhunok',
    'header-menu-my-onovylys' : 'header-menu-my-onovylys',
  }

  return (
    <ul className='hidden desktop:flex desktop:items-center gap-[12px] min-1401:gap-[22px]'>
      {
        items.map((item, index) => (
          <li key={index}>
            <a href={item.link}
               className={`text-[14px] leading-[21px] text-grey-90 no-underline ${hoverUnderlineClass} ${item.color && classRef[item.color]}`}>
              {item.title}
            </a>
          </li>
        ))
      }
    </ul>
  )
}

export default StaticMenu;